import React, {} from "react";
import Footer from "../Components/Footer";


function UserAgreement(){
  return (
    <div className="w-full h-screen  flex flex-col">
       
      <div className="px-32 pt-2   flex-1 flex justify-center ">
        <div className="w-2/3">
          <img className="my-8" alt="app icon" src={require("../images/icons/logo.png")} />
          <h1 className="font-bold text-2xl">
            End-User-License-Agreement Terms:
          </h1>
          <p>
          Thank you for using the services offered by Ignite and its subsidiaries (we, our, us). Please ensure that you 
          read these terms as they are required by law and may impact the way you use our software. By reading these terms and 
          conditions, you legally agree with our Terms. If you do not agree with these terms, please refrain from using our services. 
          </p>

          <p>
          The reason why you should read these terms carefully is that these terms and conditions hold that 
          information about your usage of services and claims offered by Ignite. Ignite requires its users to be of at 
          least 16 years or above of age before using its services. 
          </p>

          <p>
          Please make sure that you have the right authority to proceed with the usage of our services in case you are representing a 
          business or an organization on their behalf. This End-User-License-Agreement is applicable and referred to the software 
          represented and offered by Ignite only. These terms will also apply to the future updates, features, and support services
           offered by us.
          </p>
 
          <h1 className="font-bold text-2xl">
            Rights to Use the Service:
          </h1>

          <p>
          Please ensure that the device or devices you are planning or using our software on meets the minimum specifications/requirements for the Ignite software to function properly. 
          </p>

          <p>
          We also inform you that the services/products being offered under the legal affiliation of Ignite are protected by copyrights and intellectual protection laws. Under these rights, you are bound to:
          </p>

          <ul className="list-disc pl-4">
            <li> Never share access to our products and services with any third-party platform.</li>
            <li>Never copy, modify, distribute, or reproduce the product/service against our consent and acknowledgment.</li>
            <li>Never hack or reverse engineer the product/service.</li>
            <li>Never use the product/service in a way that breaches your local or international laws.</li>
            <li> Never use the software in a way that is considered a breach of this agreement.</li>
          </ul>

          <h1 className="font-bold text-2xl">Ownership:</h1>

          <p>
          Please understand that Ignite will always have the ownership of the software (offered by Ignite)
          </p>
          <p>
          Ignite will always have the ownership of the software (offered by us) that is originally installed on your device
           or devices for the first time and/or following any number of subsequent downloads. Also, the current software features, 
           updates, creatives, content, and other intellectual property within the software are owned by Ignite. Ignite holds the right 
           to issue and terminate the license to use its products to third parties.
          </p>

          <h1 className="font-bold text-2xl">Termination:</h1>
          <p>
          From the moment you install the software (offered by Ignite) on your device or devices, Ignite has the right to terminate
           your license without any prior notice if it finds you involved in any malpractices or spamming activities using our 
           software. If Ignite finds out that your usage violates the EULA and/or finds you involved in any illegal, immoral, 
           or unethical activity, your license will be terminated and you will be banned from using the service/software. 
          </p>
          <p>
          This EULA agreement, and any conflict arising out of or in connection with this EULA agreement, shall be 
          governed in accordance with the laws of the US.
          </p>
        </div>
      </div>

      <div className="bg-green-200 flex-none mt-10">
        <Footer/>
      </div>

    </div>
  );
}

export default UserAgreement;
